import ui from "@/assets/scripts/ui";

export default class {
    /*SEGUIR EXATAMENTE ESTE PADRÃO CHAMANDO form: new XXX(), POIS SE MUDAR DARÁ ERRO COM OBJETO NÃO SENDO ALTERADO A CADA INCLUSÃO*/

    constructor() {

        return {
            productionOrderId: 0,
            productionOrderCodeLabel: "",
            companyId: 0,
            typeOrigin: 0,
            productId: 0,
            quantityManually: 0,
            priorityId: 0,
            processFlowId: 0,
            deadline: ui.currentDate(),
            note: "",
            statusOrder: 0,
            originList: [],
            actionInsertType:null,
            goProcessFlowStepId:0,
            typeStopId:0,
            /*Padrão lote único, por tanto somente 1 objeto*/
            batchList: [
                {
                    productionOrderBatchId: 0,
                    lotId: 0,
                    typeNonConformanceId:0,
                    typeRestrictionId:0,
                    batchNumber: 1,
                    producedWeight: 0,
                    requestQuantity: 0,
                    producedQuantity: 0, /*todo quando estiver na última etapa antes da finalização e caso o valor produzido não tenha sido informado, deverá exigir para finalizar a OP*/
                    batchType: 1,
                    viewReportId: 0,
                    deadline: ui.currentDate(),
                    pdfReportId: 0,
                    statusBatch: 1,

                }
            ]
        }

    }
}